
import Utils from "@/components/Utils";
import { defineComponent, onMounted, onUnmounted, ref } from "vue";
import { useRouter, useRoute } from "vue-router";
import isMobile from "ismobilejs";
import { Swiper, SwiperSlide } from "swiper/vue/swiper-vue";
import SwiperNavi from "@/components/SwiperNavi.vue";

export default defineComponent({
  components: {
    Swiper,
    SwiperSlide,
    SwiperNavi,
  },
  setup(props, context) {
    context.emit("header", true);
    context.emit("contentShow", false);

    const route = useRoute();
    const main = ref<HTMLElement>();
    const router = useRouter();
    const step = ref<number>(0);
    const prevButton = ref();
    const nextButton = ref();
    const mobile =
      isMobile(window.navigator).phone || isMobile(window.navigator).tablet;
    const contents = [
      {
        image: "joy_01.png",
        mobileImage: "info_sp_16.png",
        title: "パビリオン紹介",
        text: "ジョーズ・タウンには6つのパビリオンがあります。それぞれのパビリオンを簡単に紹介します。",
      },
      {
        image: "joy_02.png",
        mobileImage: "joy_sp_01.png",
        title: "パビリオン紹介",
        text: "創業以来、一条が大切にしている住まいの「性能」について学べるパビリオンです。映像を見たり、画面を操作したりしながら詳しく学べます。",
      },
      {
        image: "joy_03.png",
        mobileImage: "joy_sp_02.png",
        title: "パビリオン紹介",
        text: "実在する一条のモデルハウスを見学できるパビリオンです。内観や住宅設備を簡単操作で360度すみずみまでご覧いただけます。",
      },
      {
        image: "joy_04.png",
        mobileImage: "joy_sp_03.png",
        title: "パビリオン紹介",
        text: "超小型ドローンがオーナー様の住まいに潜入。縦横無尽にドローンが飛び回り、オーナー様の暮らしをいつもと違った視点でご覧いただけます。 ",
      },
      {
        image: "joy_05.png",
        mobileImage: "joy_sp_04.png",
        title: "パビリオン紹介",
        text: "生活のお悩みを解決するアイデアや、暮らしと密接に関わる住まいの性能等、お役立ち情報をたくさんお届けします。",
      },
      {
        image: "joy_06.png",
        mobileImage: "joy_sp_05.png",
        title: "パビリオン紹介",
        text: "オーナー様ご自身が撮影したルームツアー動画です。使い勝手や収納の活用術等、住んでいるからこそ分かるポイントをお話しいただいています。 ",
      },
      {
        image: "joy_07.png",
        mobileImage: "joy_sp_06.png",
        title: "パビリオン紹介",
        text: "実際の暮らしをイメージして設計された「リアルサイズ」モデルハウス。間取りを検討する際に役立つポイントをたくさんご紹介しています。",
      },
      {
        image: "info_22.png",
        mobileImage: "info_sp_20.png",
        title: "クイズに挑戦しよう！",
        text: "タウンには、パビリオンに関連するクイズを出題してくれる個性豊かなキャラクターがいます。話しかけて、楽しく家づくりについて学びましょう。",
      },
      {
        image: "info_23.png",
        mobileImage: "info_sp_22.png",
        title: "ジョーくんを探せ！",
        text: "ジョーズ・タウンに隠れているジョーくんを見つけましょう！1日1回どこかに隠れています。",
      },
      {
        image: "info_25.png",
        mobileImage: "info_sp_23.png",
        title: "トロフィーを集めよう！",
        text: "パビリオンを巡ったり、クイズに正解すると、トロフィーを獲得できます。",
      },
      {
        image: "info_26.png",
        mobileImage: "info_sp_24.png",
        title: "一条マイスターになろう！",
        text: "トロフィーを集めると一条マイスターになれます。5個獲得でブロンズ、10個獲得でシルバー、20個獲得でゴールドマイスター！",
      },
      {
        image: "info_28.png",
        mobileImage: "info_sp_25.png",
        title: "一条マイスターになろう！",
        text: "獲得したトロフィーの個数とランクは画面右上で確認できます。",
      },
      {
        image: "info_29.png",
        mobileImage: "info_sp_26.png",
        title: "一条マイスターになろう！",
        text: "ゴールドマイスターになるとアバターがパワーアップ！どうなるかはお楽しみ！",
      },
      {
        image: "joy_08.png",
        mobileImage: "joy_sp_08.png",
        title: "ジョーズ・タウンを楽しもう！",
        text: "一条の「家は、性能。」にまつわるさまざまなコンテンツと出会い、家づくりのはじまりをぜひ楽しんでください。",
      },
    ];

    const prev = (index: number) => {
      step.value = index;
    };

    const next = (index: number) => {
      step.value = index;
    };

    const onSlideChange = (value: any) => {
      step.value = value.activeIndex;
    };

    const enter = () => {
      step.value = 0;
      router.push("/park");
    };

    const iPhone = isMobile(window.navigator).apple.phone;
    let resizeFlag = false;
    const resize = () => {
      let height = Utils.contentHeight("px");
      if (resizeFlag && iPhone) {
        height = "calc(100vh - 50px)";
        resizeFlag = false;
      }

      if (main.value) main.value.style.height = height;

      if (window.innerHeight !== document.documentElement.clientHeight)
        resizeFlag = true;
    };

    const keyEvent = (event: KeyboardEvent) => {
      if (route.path !== "/about") return;
      if (event.code === "ArrowLeft" && prevButton.value) {
        prevButton.value.prev();
      }
      if (
        (event.code === "Enter" || event.code === "ArrowRight") &&
        nextButton.value
      ) {
        nextButton.value.next();
      }
    };

    onMounted(() => {
      resize();
      window.addEventListener("resize", () => resize());
      if (iPhone) window.addEventListener("scroll", () => scroll());
      window.addEventListener("keydown", keyEvent, false);
    });

    onUnmounted(() => {
      window.removeEventListener("keydown", keyEvent, false);
    });

    return {
      main,
      mobile,
      step,
      contents,
      prev,
      next,
      onSlideChange,
      prevButton,
      nextButton,
      enter,
    };
  },
});
